// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__1iEUi","modalFooterButton":"ModalNotes_modalFooterButton__1Xckr"};